// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const RESET = '@auth/RESET';
export const REGISTER = '@auth/REGISTER';
